export const URI_ACCOUNT_AVAILABLE_ROLES = 'account/role/available';
